import React, { Component, useEffect, useState } from "react";
import $ from "jquery";

import backIcon from "../../../../../images/transcribe/arrow-left.svg";
import sendIcon from "../../../../../images/transcribe/send-icon.svg";
import uploadIcon from "../../../../../images/transcribe/upload-icon.png";
import marked from "marked";
import { Card, Radio, Button, Upload, Popover, Segmented, Input } from "antd";
import {
  AppstoreOutlined,
  FileTextOutlined,
  LinkOutlined,
  InfoCircleOutlined,
  InfoCircleFilled,
  PlusCircleOutlined,
  FileAddOutlined,
  CloseCircleTwoTone,
  DeleteTwoTone,
  ExportOutlined,
  FullscreenExitOutlined,
  EditOutlined,
  DeleteOutlined,
  PlusOutlined,
  TagsOutlined,
  CheckCircleOutlined,
  PlayCircleOutlined,
  StopOutlined,
  GlobalOutlined,
  PauseCircleOutlined,
  FontSizeOutlined,
} from "@ant-design/icons";
import { connect, useSelector, useDispatch } from "react-redux";
import {
  uploadDocumentTranscribe,
  uploadFileURLTranscribe,
  uploadTextTranslate,
  uploadInstructionV2,
  getWalkthroughs,
  updateSystemPrompt
} from "../../../../../redux/actions/collectionsV2";
import { notify } from "../../../../../components/Snack";
import { useHistory, useLocation } from "react-router-dom";

const Transcribe = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const queryParams = useLocation().search;

  const collectionName = new URLSearchParams(queryParams).get("name");
  const groupPlan = useSelector((state) => state.userReducer.groupPlan);
  let planType;
  if (groupPlan?.planId == 4) {
    planType = "team";
  } else if (groupPlan?.planId == 5) {
    planType = "business";
  } else {
    planType = "pro";
  }

  const [uploadFileListTemp, setUploadFileListTemp] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [translateInputText, setTranslateInputText] = useState("");
  const [fileURLText, setFileURLText] = useState("");

  useEffect(() => {
    const fetchData = async () => {
     dispatch(
        getWalkthroughs(collectionName)
      );
    }
    fetchData();
  }, []);

  const props = {
    onChange(info) {
      
      const objectList = [{
        name: info.file.name,
        originFileObj: info.file,
        size: info.file.size,
      }];
      setUploadFileListTemp(objectList);
    },
  };

  const addFile = async () => {
  
    try {
      setIsLoading(true);
      const validFileTypes = [
        "mp3",
        "mp4",
        "wav",
        "webm",
      ];

      const docFileTypeArray = uploadFileListTemp[0]?.originFileObj?.name?.split(".");
      const docFileType = docFileTypeArray ? docFileTypeArray[docFileTypeArray?.length - 1] : null;
      
     
       
        if (uploadFileListTemp?.length > 0) {

          const fileSize = uploadFileListTemp[0]?.originFileObj?.size;
          const fileMb = fileSize / 1024 / 1024;
          if(fileMb <= 25){
            if (validFileTypes.includes(docFileType)) {

            dispatch(notify("success", "Processing uploaded file..."));
            setTranscribedText("");
            setTranslatedText("");
            setAnalyzedText("");

            let createResponse = await uploadDocumentTranscribe(
              collectionName,
              uploadFileListTemp[0]?.originFileObj,
              planType,
              value
            );

            setIsLoading(false);

            let htmlResponseParsed = createResponse?.transcribed_text
              ? marked(createResponse?.transcribed_text)
              : "";
            setTranscribedText(htmlResponseParsed);
            htmlResponseParsed = createResponse?.analysis
              ? marked(createResponse?.analysis)
              : "";
            setAnalyzedText(htmlResponseParsed);
            setTranslatedText(createResponse?.translated_text);
            }else {
              dispatch(
                notify(
                  "error",
                  "Please upload a valid file type"
                )
              );
              setIsLoading(false);
            }
          }else{
            setIsLoading(false);
              dispatch(
                notify(
                  "error",
                  `Please upload a file with size less than 25 MB`
                )
              );
          }
        } else {
          dispatch(notify("error", "Please select a file to upload"));
          setIsLoading(false);
        }
    } catch (err) {
      setIsLoading(false);
      dispatch(
        notify("error", "Something went wrong, please refresh the page")
      );
      console.log("Error while retrieving", err.message);
    }
  };
  const addText = async () => {
    try {
      if (translateInputText?.length > 0) {
        setIsLoading(true);
        dispatch(notify("success", "Processing input text..."));
        setTranscribedText("");
        setTranslatedText("");
        setAnalyzedText("");

        let createResponse = await uploadTextTranslate(
          collectionName,
          translateInputText,
          planType,
          value
        );
        setIsLoading(false);

        let htmlResponseParsed = createResponse?.transcribed_text
          ? marked(createResponse?.transcribed_text)
          : "";
        setTranscribedText(htmlResponseParsed);
        htmlResponseParsed = createResponse?.analysis
          ? marked(createResponse?.analysis)
          : "";
        setAnalyzedText(htmlResponseParsed);
        setTranslatedText(createResponse?.translated_text);
        setTranslateInputText("");
      } else {
        dispatch(notify("error", "Please input a valid text"));
        setIsLoading(false);
      }
    } catch (err) {
      dispatch(
        notify("error", "Something went wrong, please refresh the page")
      );
      setIsLoading(false);
    }
  };

  const addFileURL = async () => {
    try {

      if (
        !(
          fileURLText.startsWith("http://") ||
          fileURLText.startsWith("https://")
        )
      ) {
        dispatch(notify("error", "Please enter a valid URL"));
        return;
      }

      if (fileURLText.length > 0) {
        setIsLoading(true);
        dispatch(notify("success", "Processing File URL..."));
        setTranscribedText("");
        setTranslatedText("");
        setAnalyzedText("");

        const fileURLTextFinal = fileURLText?.replace(/\s*$/,'');

        let createResponse = await uploadFileURLTranscribe(
          collectionName,
          fileURLTextFinal,
          planType,
          value
        );
        setIsLoading(false);

        let htmlResponseParsed = createResponse?.transcribed_text
          ? marked(createResponse?.transcribed_text)
          : "";
        setTranscribedText(htmlResponseParsed);
        htmlResponseParsed = createResponse?.analysis
          ? marked(createResponse?.analysis)
          : "";
        setAnalyzedText(htmlResponseParsed);
        setTranslatedText(createResponse?.translated_text);
        setTranslateInputText("");
      } else {
        dispatch(notify("error", "Please input a valid text"));
        setIsLoading(false);
      }
    } catch (err) {
      dispatch(
        notify("error", "Something went wrong, please refresh the page")
      );
      console.log(err)
      setIsLoading(false);
    }
  };

  let additionalInstructionsValue = useSelector(
    (state) => state.collectionReducer.instructionData
  );
  let systemPromptValue = useSelector(
    (state) => state.collectionReducer.systemPrompt?.prompt
  );
  const userEmail = useSelector((state) => state.userReducer.user?.email);

  const [value, setValue] = useState(`["transcribe", "translate", "analyze"]`);
  const [additionalInstructionValue, setAdditionalInstuctionValue] = useState(additionalInstructionsValue);
  const [systemPromptText, setSystemPromptText] = useState(systemPromptValue);
  const [transcribedText, setTranscribedText] = useState("");
  const [analyzedText, setAnalyzedText] = useState("");
  const [translatedText, setTranslatedText] = useState("");
  const [fileUploadMode, setFileUploadMode] = useState(true);

  useEffect(() => {
    setAdditionalInstuctionValue(additionalInstructionsValue);
  }, [additionalInstructionsValue]);

  useEffect(() => {
    setSystemPromptText(systemPromptValue);
  }, [systemPromptValue]);

  const updateAdditionalInstruction = async () => {
    const updateResponse = await uploadInstructionV2(collectionName, additionalInstructionValue);
    if(updateResponse?.status == 200){
      dispatch(notify("success", "User Instructions updated"));
      dispatch(getWalkthroughs(collectionName));
    }else {
      dispatch(notify("error", "User Instructions updation failed. Please try again."));
    }
  };

  const updateSystemPromptValue = async () => {
    const updateResponse = await updateSystemPrompt(collectionName, userEmail, systemPromptText);
    if(updateResponse?.status == 200){
      dispatch(notify("success", "System prompt updated"));
      dispatch(getWalkthroughs(collectionName));
    }else {
      dispatch(notify("error", "System prompt updation failed. Please try again."));
    }
  };

  const onChange = (e) => {
    setValue(e.target.value);
    if (
      e.target.value == `["analyze"]` ||
      e.target.value == `["translate","analyze"]`
    ) {
      setFileUploadMode(false);
    } else {
      setFileUploadMode(true);
    }
    setTranscribedText("");
    setTranslatedText("");
    setAnalyzedText("");
  };

  const onChangeAdditionalInstruction = (e) => {
    setAdditionalInstuctionValue(e.target.value);
  };
  const onChangeSystemPromptValue = (e) => {
    setSystemPromptText(e.target.value);
  };

  const minMode = useSelector((state) => state.appReducer.minMode);

  const transcribeTranslateAnalysis = (
    <ul className="popt-content">
      <li><strong>Transcribe:</strong> Performs speech-to-text conversion from audio/video file.</li>
      <li><strong>Translate:</strong> Translates the transcribed text into the specified language set during collection setup.</li>
      <li><strong>Analyze:</strong> Generates a report based on the provided system prompt, additional instructions, and the transcript, in the designated language set during collection setup.</li>
    </ul>
  );

  const transcribeTranslate = (
    <ul className="popt-content">
      <li><strong>Transcribe:</strong> Performs speech-to-text conversion from audio/video file.</li>
      <li><strong>Translate:</strong> Translates the transcribed text into the specified language set during collection setup.</li>
    </ul>
  );

  const transcribeAnalysis = (
    <ul className="popt-content">
      <li><strong>Transcribe:</strong> Performs speech-to-text conversion from audio/video file.</li>
      <li><strong>Analyze:</strong> Generates a report based on the provided system prompt, additional instructions, and the transcript.</li>
    </ul>
  );

  const translateAnalysis = (
    <ul className="popt-content">
      <li><strong>Translate:</strong> Translates the transcript provided as text into the specified language set during collection setup.</li>
      <li><strong>Analyze:</strong> Generates a report based on the provided system prompt, additional instructions, and the transcript, in the designated language set during collection setup.</li>
    </ul>
  );
  const analysis = (
    <ul className="popt-content">    
      <li><strong>Analyze:</strong> Generates a report based on the provided system prompt, additional instructions, and the transcript provided as text.</li>
    </ul>
  );

  const [apply, setApply] = useState('Upload File');

  return (
    <div className="page-layout-sidebar">
      <div
        className={
          minMode ? "task-list sidebar-inner active" : "task-list sidebar-inner"
        }
      >
        <div className="sidebar-inner">
          <div className="s-title">
            <div
              className="back-icon"
              onClick={() => history.push(`/dashboard/skills/collections`)}
            >
              <img src={backIcon} alt="back icon" />
            </div>
            <h1>{collectionName?.slice(collectionName.indexOf("_") + 1)}</h1>
          </div>
          <div className="s-textarea-box">
            <h4>System Prompt</h4>
            <div className="text-wrapper">
              <textarea
                placeholder="Write your prompt here"
                name=""
                id=""
                value={systemPromptText}
                onChange={onChangeSystemPromptValue}
              ></textarea>
              <div onClick={() => updateSystemPromptValue()} className="send-btn">
                {/* <img src={sendIcon} alt="submit" /> */}
                <Button type="primary" style={{borderRadius: '20px'}}>Save</Button>
              </div>
            </div>
          </div>
          <div className="s-textarea-box">
            <h4>Additional Instructions</h4>
            <div className="text-wrapper">
              <textarea
                placeholder="Write your instructions here"
                name=""
                id=""
                value={additionalInstructionValue}
                onChange={onChangeAdditionalInstruction}
              ></textarea>
              <div onClick={() => updateAdditionalInstruction()} className="send-btn">
                {/* <img src={sendIcon} alt="submit" /> */}
                <Button type="primary" style={{borderRadius: '20px'}}>Save</Button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="page-right">
        <div className="page-right-inner">
          <div className="ts-card-block">
            <Card
              // title="Default size card"
              extra={
                <Radio.Group onChange={onChange} value={value} className="radio-transcribe">
                  <Radio value={`["transcribe", "translate", "analyze"]`}>
                    Transcribe - Translate - Analyze 
                    <Popover content={transcribeTranslateAnalysis}>{" "}<InfoCircleFilled /></Popover>
                  </Radio>
                  <Radio value={`["transcribe", "translate"]`}>
                    Transcribe - Translate
                    <Popover content={transcribeTranslate}>{" "}<InfoCircleFilled /></Popover>
                  </Radio>
                  <Radio value={`["transcribe","analyze"]`}>
                    Transcribe - Analyze
                    <Popover content={transcribeAnalysis}>{" "}<InfoCircleFilled /></Popover>
                  </Radio>
                  <Radio value={`["analyze"]`}>
                    Analyze
                    <Popover content={analysis}>{" "}<InfoCircleFilled /></Popover>
                  </Radio>
                  <Radio value={`["translate","analyze"]`}>
                    Translate - Analyze
                    <Popover content={translateAnalysis}>{" "}<InfoCircleFilled /></Popover>
                  </Radio>
                </Radio.Group>
              }
            >
              <div className="file-upload-text">
                {fileUploadMode ? (
                <>
                  <div className="select-type">
                    <Segmented
                      options={['Upload File', 'Enter URL']}
                      // onChange={(value) => {
                      //   console.log(value); // string
                      // }}
                      value={apply}
                      onChange={setApply}
                    />
                  </div>
                  {apply === 'Upload File' ? <div className="flex-items-ts-col">
                  <div className="flex-items-ts">                    
                    <div className="tsu-icon-text">
                      <img src={uploadIcon} alt="upload" />
                      <div className="tsu-text">
                        <h4>Upload your documents here</h4>
                        <p>
                          Limit 25MB per file • MP3, WAV, MP4, WEBM
                        </p>
                      </div>
                    </div>
                    <div className="upload-file-text">
                      <Upload 
                        {...props} 
                        beforeUpload={() => false}
                        maxCount={1}
                        >
                        <Button
                          type="default"
                          icon={<FileAddOutlined />}
                          size="small"
                          //disabled={isLoading ? true : false}
                        >
                          Browse Files
                        </Button>
                      </Upload>
                    </div>                   
                    </div>
                    <hr />
                    <div className="text-center">
                      {!isLoading ? (
                        <Button onClick={(e) => addFile()} type="primary">
                          Submit File
                        </Button>
                      ) : (
                        <Button type="primary">Processing...</Button>
                      )}
                    </div>
                  </div> : 
                  <div className="flex-items-ts-col">
                  <div className="flex-items-ts">                    
                    <div className="up-input">
                      <Input 
                      placeholder="Enter your URL" 
                      onChange={(e) => setFileURLText(e.target.value)}
                      />
                    </div>                   
                  </div>
                    <div className="text-center " style={{marginTop: '20px'}}>
                      {!isLoading ? (
                        <Button onClick={(e) => addFileURL()} type="primary">
                          Submit
                        </Button>
                      ) : (
                        <Button type="primary">Processing...</Button>
                      )}
                    </div>
                  </div>
                  }
                </>
                ) : (
                  <div className="text-wrapper">
                    <textarea
                      value={translateInputText}
                      onChange={(e) => setTranslateInputText(e.target.value)}
                      placeholder="Write your text to be translated"
                      name=""
                      id=""
                    ></textarea>
                    <div className="text-center" style={{marginTop: '5px'}}>
                    {!isLoading ? (
                    <Button type="primary" className="send-btn" onClick={(e) => addText()}>
                      Submit
                    </Button>
                    ) : (
                      <Button type="primary" className="send-btn">
                      Processing....
                    </Button>
                    )}
                    </div>                    
                  </div>
                )}
              </div>
            </Card>
            <Card className="card-scrollable scrollable">
              
              
                {value.includes("transcribe") && transcribedText?.length > 0 ?
                <>
                <h3>Transcript</h3>
                <div dangerouslySetInnerHTML={{ __html: transcribedText }}></div>
                <hr />
                </>
                 : null}
                   {value.includes("translate") && translatedText?.length > 0 ?
                <>
                  <h3>Translation</h3>                  
                  <div>{translatedText}</div>
                  <hr />
                  </>
                  : null}
                   {value.includes("analyze") && analyzedText?.length > 0 ?
                <>
                <h3>Analysis</h3>                
                <div dangerouslySetInnerHTML={{ __html: analyzedText }}></div>
                </> : null}
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Transcribe;
